import {
  Wrench,
  CircleCheck,
  Brush,
  BedDouble,
  CalendarCheck,
  Ban,
  CircleDashed,
  LogIn,
  LogOut,
  RotateCcw,
} from "lucide-react";

// Same hues as the old /admin rooms grid (so staff recognise them instantly) but rendered as CALM
// SOFT tints — pale background + strong-hue text + subtle border — which suit this lighter UI and stay
// WCAG-safe (dark text on light). Every status = COLOR + ICON + TEXT. Two badge families, kept distinct
// by fill + shape + caption:
//   • PHYSICAL room status -> soft FILLED rounded chip   (variant="soft")
//   • BOOKING/date status  -> OUTLINE pill               (variant="outline")

export const PHYSICAL_STATUS_META = {
  vacant_clean: {
    labelKey: "status_vacant_clean",
    Icon: CircleCheck,
    bg: "#28a745",
    fg: "#ffffff",
    border: "#28a745",
  },
  vacant_dirty: {
    labelKey: "status_vacant_dirty",
    Icon: Brush,
    bg: "#fd7e14",
    fg: "#ffffff",
    border: "#fd7e14",
  },
  occupied_dirty: {
    labelKey: "status_occupied_dirty",
    Icon: BedDouble,
    bg: "#dc3545",
    fg: "#ffffff",
    border: "#dc3545",
  },
  maintenance: {
    labelKey: "status_maintenance",
    Icon: Wrench,
    bg: "#212121",
    fg: "#ffffff",
    border: "#212121",
  },
};

// Booking / date status. Outline pills — one accent colour each.
export const RESERVATION_META = {
  reserved: { labelKey: "reserved", Icon: CalendarCheck, color: "#b45309" },
  available: { labelKey: "available", Icon: CircleDashed, color: "#15803d" },
  // `solid`: render as a solid-black badge (white text) so a blocked room is impossible to miss.
  blocked: {
    labelKey: "blocked",
    Icon: Ban,
    color: "#334155",
    solid: "#000000",
  },
};

// Guest-activity chips (ExportService `badge_slots`), keyed by slot label. Soft tints.
// `tint`/`accent` colour the whole activity BLOCK on the rack card (paler than the chip bg, so text
// contrast holds): the colour itself tells the FO what kind of guest movement this is.
export const FOOTER_META = {
  Stay: {
    Icon: BedDouble,
    bg: "#e7f0fb",
    fg: "#1d5fa8",
    tint: "#f3f7fc",
    accent: "#1d5fa8",
  },
  CI: {
    Icon: LogIn,
    bg: "#e8f6ee",
    fg: "#157347",
    tint: "#f4faf6",
    accent: "#157347",
  },
  CO: {
    Icon: LogOut,
    bg: "#fdeee1",
    fg: "#c2410c",
    tint: "#fdf6ef",
    accent: "#c2410c",
  },
  "Early CO": {
    Icon: LogOut,
    bg: "#fdeee1",
    fg: "#c2410c",
    tint: "#fdf6ef",
    accent: "#c2410c",
  },
  Reopen: {
    Icon: RotateCcw,
    bg: "#fdeee1",
    fg: "#c2410c",
    tint: "#fdf6ef",
    accent: "#c2410c",
  },
};

// Overdue / plain-reservation block (a reserved line spanning the date with no activity bucket —
// e.g. an arrival that never checked in). Amber: needs FO attention.
export const RESERVED_BLOCK_META = { tint: "#fdf8e9", accent: "#b45309" };

export const physicalStatusMeta = (status) =>
  PHYSICAL_STATUS_META[status] || PHYSICAL_STATUS_META.maintenance;
export const footerMeta = (label) =>
  FOOTER_META[label] || {
    Icon: CircleDashed,
    bg: "#eef1f5",
    fg: "#475569",
    tint: "#fbfaf7",
    accent: "#c8c2b4",
  };
